import router from '@/router'
import { getToken } from '@/utils/cookies'
// 在有token的情况下, 进入这些页面, 重定向到home
// const HASTOKENNOENTER = ['login', 'register', 'home']
const token = getToken()
router.beforeEach((to, from, next) => {
  if(token && token.length > 0) { next()}
  else {
    if(to.meta.requireAuth) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  }
/*
    if (to.meta.requireAuth) {
      if (token) {
        next()
      } else {
        next({
          path: '/login'
        })
      }
    } else {
      if (token && HASTOKENNOENTER.includes(to.name)) {
        next({ path: '/' })
      } else {
        next()
      }
    }
      */
})
